// extracted by mini-css-extract-plugin
module.exports = {"tabsBox":"FJTabs_tabsBox__sbZBF","tabsItem":"FJTabs_tabsItem___RbwA","tabsItemActive":"FJTabs_tabsItemActive__aiZek","animation":"FJTabs_animation__HFjE6"};